import { Pagination } from "@src/shared/api/generated"

type CollectionMockContext = {
  calcOffset: (page?: number) => number
  pageSize: number
}

export type CollectionMockResponse<T> = {
  data: T[]
  pagination: Pagination
}

export type CollectionMockResolver<T> = (
  req: unknown,
  context: CollectionMockContext,
) => CollectionMockResponse<T>

const collectionMocks = new Map<string, CollectionMockResolver<unknown>>()

export const isCollectionMockModeEnabled = () =>
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_COLLECTION_MOCKS === "true"

export const registerCollectionMock = <T>(
  key: string,
  resolver: CollectionMockResolver<T>,
) => {
  collectionMocks.set(key, resolver as CollectionMockResolver<unknown>)
}

export const getCollectionMock = <T>(key: string) =>
  collectionMocks.get(key) as CollectionMockResolver<T> | undefined
